export const PlayIconRed = () => {
    return (
        <svg
            width="50"
            height="50"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 0.537109C8.02219 0.537109 6.08879 1.07344 4.4443 2.07829C2.79981 3.08313 1.51809 4.51136 0.761209 6.18235C0.00433284 7.85335 -0.193701 9.69206 0.192152 11.466C0.578004 13.2399 1.53041 14.8694 2.92894 16.1483C4.32746 17.4272 6.10929 18.2982 8.0491 18.651C9.98891 19.0039 11.9996 18.8228 13.8268 18.1306C15.6541 17.4385 17.2159 16.2664 18.3147 14.7625C19.4135 13.2586 20 11.4906 20 9.68192C20 8.48101 19.7413 7.29185 19.2388 6.18235C18.7363 5.07285 17.9997 4.06474 17.0711 3.21556C16.1425 2.36639 15.0401 1.69279 13.8268 1.23322C12.6136 0.773647 11.3132 0.537109 10 0.537109ZM8 13.7971V5.56675L14 9.68192L8 13.7971Z"
                fill="#EC1C24"
            />
        </svg>
    );
};
